module.exports = __webpack_public_path__ + "img/xmsb3.afaa8dd0.png";